import React from 'react';
import { Property } from '../../services/api';

// 5-0. 공식 홈페이지 — KV 아래 강조 액션 (사용자 요청 2026-05-19 / 강조 2026-08-12)
//   메모리 feedback_hide_applyhome: is_custom_homepage=true 일 때만 노출.
//   2026-08-12: "잘 보이게" 요청 — 작은 아웃라인 칩 → 전폭 accent 배너로 승격.
//   2026-08-24: 라벨 '공식 홈페이지 바로가기' → '홈페이지 바로가기', 15px→18px, 중앙정렬(대표 요청).
//   2026-09-22: "기본 오렌지 배경으로 잘 보이게"(대표) — tint → solid accent(#FF6B00) + 흰 글자.
export const OfficialHomepageLink: React.FC<{ property: Property }> = ({ property }) => {
  if (!((property as any).homepage_url && (property as any).is_custom_homepage)) return null;
  return (
    <section className="bg-frame px-4 pb-3 md:px-6">
      <a
        href={(property as any).homepage_url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex w-full items-center gap-2.5 rounded-ca-md border border-accent bg-accent px-4 py-3.5 text-white shadow-ca-cta transition-colors hover:bg-accent-dark"
      >
        <svg width={19} height={19} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
        <span className="flex-1 text-center text-[18px] font-extrabold leading-tight">
          홈페이지 바로가기
          <span className="mt-1 block text-[12.5px] font-semibold opacity-75">
            분양 안내 · 평면 · 단지 정보 전체 보기
          </span>
        </span>
        <svg width={17} height={17} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </a>
    </section>
  );
};
